import React from 'react';

// Pictogrammes des machines dont nous n'avons pas encore de photo utilisable.
// Dessines a la main, en trait, dans les couleurs du site : c'est une attente
// assumee, pas une image cassee. Ils sont remplaces par la vraie photo des que
// le client nous l'envoie.

const TRAITS = {
  fill: 'none',
  strokeWidth: 5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function Chariot() {
  return (
    <g {...TRAITS}>
      {/* mat */}
      <path d="M96 42 L96 148" stroke="#1B6AA5" />
      <path d="M108 42 L108 148" stroke="#1B6AA5" />
      {/* tablier et fourches */}
      <path d="M96 108 L96 142" stroke="#6E7A87" />
      <path d="M96 142 L50 142" stroke="#6E7A87" />
      {/* palette portee */}
      <path d="M54 108 L94 108 L94 138 L54 138 Z" stroke="#F5B301" />
      <path d="M54 124 L94 124" stroke="#F5B301" strokeWidth="3" />
      {/* chassis et contrepoids */}
      <path d="M112 148 L112 112 L200 112 L200 148 Z" stroke="#1B6AA5" />
      {/* arceau de protection */}
      <path d="M122 112 L122 48 L192 48 L192 112" stroke="#6E7A87" />
      {/* siege */}
      <path d="M150 108 L150 88 L176 88" stroke="#1B6AA5" />
      {/* roues */}
      <circle cx="130" cy="160" r="13" stroke="#1B6AA5" />
      <circle cx="184" cy="160" r="13" stroke="#1B6AA5" />
      <path d="M34 178 L226 178" stroke="#6E7A87" strokeWidth="3" />
    </g>
  );
}

function Nacelle() {
  return (
    <g {...TRAITS}>
      {/* plateforme et garde-corps */}
      <path d="M62 62 L194 62" stroke="#1B6AA5" />
      <path d="M62 62 L62 30 L194 30 L194 62" stroke="#F5B301" />
      <path d="M62 46 L194 46" stroke="#F5B301" strokeWidth="3" />
      {/* ciseaux */}
      <path d="M78 62 L178 132" stroke="#6E7A87" />
      <path d="M178 62 L78 132" stroke="#6E7A87" />
      {/* chassis */}
      <path d="M58 132 L198 132 L198 160 L58 160 Z" stroke="#1B6AA5" />
      <circle cx="88" cy="168" r="13" stroke="#1B6AA5" />
      <circle cx="168" cy="168" r="13" stroke="#1B6AA5" />
      <path d="M32 183 L224 183" stroke="#6E7A87" strokeWidth="3" />
    </g>
  );
}

function Compresseur() {
  return (
    <g {...TRAITS}>
      {/* caisson */}
      <path d="M56 66 L184 66 L184 138 L56 138 Z" stroke="#F5B301" />
      <path d="M56 90 L184 90" stroke="#F5B301" strokeWidth="3" />
      {/* ouies de ventilation */}
      <path d="M72 106 L104 106" stroke="#6E7A87" strokeWidth="4" />
      <path d="M72 118 L104 118" stroke="#6E7A87" strokeWidth="4" />
      {/* chassis et timon */}
      <path d="M48 138 L192 138 L192 152 L48 152 Z" stroke="#1B6AA5" />
      <path d="M192 145 L232 156" stroke="#1B6AA5" />
      <path d="M226 152 L238 162" stroke="#1B6AA5" />
      {/* bequille et roue */}
      <path d="M62 152 L62 172" stroke="#6E7A87" />
      <circle cx="140" cy="166" r="17" stroke="#1B6AA5" />
      <path d="M28 185 L236 185" stroke="#6E7A87" strokeWidth="3" />
    </g>
  );
}

const DESSINS = { chariot: Chariot, nacelle: Nacelle, compresseur: Compresseur };

export default function Pictogramme({ nom, classe = '' }) {
  const Dessin = DESSINS[nom];
  if (!Dessin) return null;
  return (
    <svg
      viewBox="0 0 260 200"
      className={classe}
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <Dessin />
    </svg>
  );
}
